module.exports = __webpack_public_path__ + "img/env_3.1a81afc3.jpg";